import ProgramIconMeny from "@/public/KinoIconMeny.svg";
import KulturIconMeny from "@/public/KulturIconMeny.svg";
import VelgFilmIconMeny from "@/public/VelgFilmMeny.svg";
import classNames from "classnames";
import { Hotlink } from 'lib/types/Settings';
import Link from "next/link";
import styles from "./Hotlink.module.css";

//#region [Props]
type LinkProps = {
    $hideOnSmallScreens?: boolean;
}

type HotlinkProps = {
    hotlink: Hotlink;
    useAnchors?: boolean;
} & LinkProps;
//#endregion

//#region [Component]
export default function HotlinkMenuItem({ hotlink, $hideOnSmallScreens: hideOnSmallScreens = false, useAnchors = false }: HotlinkProps) {
    let href = "";
    let icon = null;
    const prefix = useAnchors ? "#" : "/";
    switch (hotlink._type) {
        case "velgfilm":
            href = "/velgfilm";
            icon = <VelgFilmIconMeny className={styles.MenyIcon} />;
            break;
        case "program":
            href = prefix + "program";
            icon = <ProgramIconMeny className={styles.MenyIcon} />;
            break;
        case "kulturprogram":
            href = prefix + "kulturprogram";
            icon = <KulturIconMeny className={styles.MenyIcon} />;
            break;
    }

    if (!href) {
        return null;
    }
    return <Link href={href} passHref legacyBehavior>
        <a className={classNames(styles.Hotlink, hideOnSmallScreens ? styles.Hotlink_hideOnSmallScreens : null)} >
            {icon}
            {hotlink.label}
        </a>
    </Link>;
}
//#endregion